import { render } from "./CaseDetailsModal.vue?vue&type=template&id=ee79fb16&scoped=true"
import script from "./CaseDetailsModal.vue?vue&type=script&lang=js"
export * from "./CaseDetailsModal.vue?vue&type=script&lang=js"

import "./CaseDetailsModal.vue?vue&type=style&index=0&id=ee79fb16&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee79fb16"]])

export default __exports__